<template>
  <div class="time">
    <time class="time__current">{{ props.currentTime }}</time>
    <time class="time__duration">{{ props.durationTime }}</time>
  </div>
</template>

<script setup>
  import { Props } from './props';
  //------------------------------------
  const props = defineProps(Props());
</script>

<style lang="scss" scoped>
  @import'./styles.scss';
</style>